import { useState } from "react";
import { PlayCircle } from "@phosphor-icons/react";

// Lazy YouTube: shows a lightweight thumbnail + play button, mounts the heavy
// iframe player only after the user taps. Prevents mobile-Safari OOM crashes
// caused by many eager YouTube iframes on one page.
export function LiteYouTube({ id, title }) {
  const [play, setPlay] = useState(false);
  if (!id) return null;
  if (play) {
    return (
      <iframe
        title={title || "video"}
        src={`https://www.youtube.com/embed/${id}?autoplay=1`}
        className="w-full h-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    );
  }
  return (
    <button
      type="button"
      data-testid="lite-yt-play"
      onClick={() => setPlay(true)}
      className="relative w-full h-full block bg-black active:opacity-90"
    >
      <img
        src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
        alt={title || "video"}
        loading="lazy"
        className="w-full h-full object-cover"
        onError={(e) => { e.currentTarget.style.opacity = 0; }}
      />
      <span className="absolute inset-0 flex items-center justify-center">
        <PlayCircle size={54} weight="fill" className="text-white/90 drop-shadow-lg" />
      </span>
    </button>
  );
}
